import {createContext} from 'react';

const CurrentWeatherContext= createContext(null);

export default CurrentWeatherContext;
